import { Trans } from '@lingui/react/macro';
import React from 'react';
import { DivProps } from 'typings';
import UDText from 'ud-ui/components/text';
import { MainBlock } from './styles';
import { theme } from 'styles/theme/theme';

interface IProps extends DivProps {
  isActive: boolean;
  isDisabled?: boolean;
  widthPercent?: number; // optional; defaults to 100%
  compact?: boolean; // renders a smaller, denser variant
  name: string;
  date?: {
    from?: string;
    to?: string;
  };
  price: number;
}

function PlanCard(props: IProps) {
  const { isActive, widthPercent = 100, name, date, price, isDisabled, compact, ...restProps } = props;
  const from = date?.from;
  const to = date?.to;

  return (
    <MainBlock width={widthPercent} isActive={isActive} isDisabled={isDisabled} $compact={compact} {...restProps}>
      <UDText type={'subhead'}>{name}</UDText>
      <UDText type={'caption-1'} style={{ flexGrow: 1, color: theme.colors.Gray96, textAlign: 'center' }}>
        {from && <Trans comment="Начало периода подписки">от {from}</Trans>}{' '}
        {to && <Trans comment="Конец периода подписки">до {to}</Trans>}
      </UDText>
      <UDText type={'subhead'} className={'bold'}>
        <Trans>{price} руб.</Trans>
      </UDText>
    </MainBlock>
  );
}

export default PlanCard;
